// extracted by mini-css-extract-plugin
export default {"offset":"app-powerDialer-Agent-SessionResponses-module__RRTD6bDwN6wR2V10tFMz"};